var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.5,
    height: 10,
    viewBox: "0 0 8.5 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_move_up",
    "data-name": "icon move up",
    transform: "translate(1522.5 610) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M5,4.582a.471.471,0,0,1-.085.275l-2.5,3.75A.5.5,0,0,1,2,8.832H.5a.5.5,0,0,1-.5-.5.472.472,0,0,1,.085-.275L2.4,4.582.085,1.107A.472.472,0,0,1,0,.832a.5.5,0,0,1,.5-.5H2a.5.5,0,0,1,.415.225l2.5,3.75A.472.472,0,0,1,5,4.582Zm0,0",
    transform: "translate(1522.832 600) rotate(90)",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M218.332,4.582a.472.472,0,0,1-.085.275l-2.5,3.75a.5.5,0,0,1-.415.225h-1.5a.5.5,0,0,1-.5-.5.472.472,0,0,1,.085-.275l2.315-3.475-2.315-3.475a.472.472,0,0,1-.085-.275.5.5,0,0,1,.5-.5h1.5a.5.5,0,0,1,.415.225l2.5,3.75A.472.472,0,0,1,218.332,4.582Zm0,0",
    transform: "translate(1522.832 391.668) rotate(90)",
    fill: "#373737"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.09a9b787d721f02f6387ec7c2dc996c1.svg";
export { ForwardRef as ReactComponent };